<template>
  <div :class="['col-xs-12', `col-md-${size}`]">
    <form-group-search-select
      ref="input"
      :label="label"
      :readonly="readonly"
      :name="name"
      :options="cursos || []"
      :data-vv-as="label"
      :placeholder="placeholder"
      :value="value"
      @input="atualizarCurso($event)"
      @change="atualizarCurso($event)"
      v-validate="{ required: required }"
    />
  </div>
</template>

<script>
import AlunoService from "../../../../domain/corpore/AlunoService";
import SwalMessage from "../../../../domain/message/SwalMessage";

export default {
  name: "c-protocolo-curso-modalidade",
  $_veeValidate: {
    validator: "new"
  },
  inject: ["$validator", "formValues"],
  props: {
    label: String,
    id: String,
    name: {
      required: true,
      type: String
    },
    size: {
      type: String,
      default: "6"
    },
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    value: String,
    required: Boolean,
    login: {
      type: String,
      default: ""
    },
    servicoId: String
  },
  computed: {
    usuario() {
      return this.$store.state.usuario;
    },
    ambienteAtual() {
      return this.$store.state.ambientes.atual;
    }
  },
  asyncComputed: {
    cursos() {
      const alunoService = new AlunoService(this.$http);

      /*
        Pode acontecer a necessidade de formalização de trancamento de matrículas e o aluno não estar com Status Ativo
        Ex: Alteração de Modalidade
      */
      const ativo = this.servicoId !== 97; // 97 - Trancamento/Cancelamento de Matrícula

      /*
        4 - Pós Live
        96 - Cancelamento de Curso - Pós-Graduação
        O serviço 96 so esta disponível para usuários do publico de Pós
      */
      const idModalidade =
        this.servicoId === "96" ? 4 : this.ambienteAtual.idModalidade;

      let login = this.login !== "" ? this.login : this.usuario.login;
      if (login) {
        /* Busca todos os cursos do aluno */
        return alunoService
          .getCursosAlunoByRa(login, ativo, idModalidade)
          .then(result =>
            result.map(curso => ({
              value: curso.CODCURSO,
              text: curso.NOME,
              codPerlet: curso.CODPERLET,
              periodo: curso.PERIODO
            }))
          )
          .catch(err => {
            SwalMessage.warningMessage(`<p>${err.message}</p>`, "Ops!");
          });
      }
    },
    setCurso() {
      if (this.cursos && this.cursos.length === 1) {
        this.$validator.reset();
        this.atualizarCurso(this.cursos[0].value.toString());
      }
    }
  },
  methods: {
    atualizarCurso(value) {
      if (value != null) {
        this.formValues.cursoId = value;
        this.$el.value = value;
        this.$emit("input", value);
      }
    }
  },
  mounted() {
    this.$el.value = this.value;
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Protocolo/Campos/CursoModalidade.vue